import { Button, Modal } from 'flowbite-react'
import React, { useState } from 'react'
import OTPInput from 'react-otp-input'
import "../OtpModal/OtpModal.css"
import { mobileOTPSignup, mobileOTPSignUpVerify } from '../../api/auth'
import toast from 'react-hot-toast'
import FormModal from '../FormModal/FormModal'
import { handleVerifyResponse } from '../../utils/landingAuth'


const OtpVerifyVisitor = ({ isOpenverifyModal, toggleModal, mobile, verifyOtp, toggleFormChitAd }) => {

    const [otp, setOtp] = useState();
    const [openForm, setOpenForm] = useState(false);

    const toggleForm = () => {
        setOpenForm(!openForm)
    }

    const otpTrigger = async () => {
        const data = {
            mobile: mobile,
            visitor: true,
        };
        if (mobile.length === 10) {
            const mobileStatus = await mobileOTPSignup(data);
            if (mobileStatus?.status >= 400) {
                toast.error(mobileStatus?.data?.msg || 'Could not resend OTP');
                return;
            }
            toast.success('OTP Resend Successfully!');
        }
    }

    const otpVerify = async () => {
        const payload = {
            mobile: mobile,
            otp,
            visitor: true,
            device_id: 'landing-web',
            ip: 'landing-page',
        }
        const updateApi = await mobileOTPSignUpVerify(payload)
        const outcome = handleVerifyResponse(updateApi, mobile, {
            onCloseModals: () => {
                setOtp('')
                toggleModal?.()
                toggleFormChitAd?.()
            },
            onShowRegistrationForm: () => setOpenForm(true),
        })

        if (!outcome.ok) {
            toast.error(outcome.message)
            return
        }

        toast.success(outcome.message || 'OTP Verified Successfully')
    }


    return (
        <>
            <Modal className='z-[2000]' show={isOpenverifyModal || verifyOtp} style={{ width: 'auto' }} onClose={toggleModal || toggleFormChitAd} popup>

                <Modal.Body>
                    <div className="text-center p-6">
                        <h1 className='text-2xl mb-3 font-bold'>OTP Verification</h1>
                        <h3 className="mb-5 text-md font-normal text-gray-500 dark:text-gray-400">
                            Enter the OTP you received at <span className='text-navydark font-bold'>+91 {mobile}</span>
                        </h3>
                        <div className='flex justify-center'>
                            <OTPInput
                                value={otp}
                                onChange={(e) => setOtp(e)}
                                inputType="tel"
                                numInputs={6}
                                inputStyle="custom-otp-field"
                                renderInput={(props) => <input {...props} />}
                            />

                        </div>
                        <div className="flex justify-center mt-5">
                            <Button color="dark" size='sm' className='bg-primaryColor' disabled={!otp || otp.length !== 6} onClick={otpVerify}>
                                Verify
                            </Button>
                        </div>
                        <p className='text-sm mt-3 text-gray-500'>Didn't receive code? <span className='text-teal-600 underline cursor-pointer' onClick={otpTrigger}>Request again</span></p>
                    </div>
                </Modal.Body>
            </Modal>

            <FormModal isOpenForm={openForm} toggleForm={toggleForm} mobile={mobile} onHandoffComplete={() => setOpenForm(false)} />
        </>
    )
}

export default OtpVerifyVisitor
